export default __webpack_public_path__ + "static/media/form-name-placeholder.ab71b6a1.png";